import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${rem(16)};
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
`;

export const Page = styled.div`
  padding: 0 ${rem(32)};
`;
